const textAreaStyles = {
  padding: '5px 7px'
};

export { textAreaStyles as t };
//# sourceMappingURL=textarea-CNkfng2a.js.map
